import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getRoles } from '../../core/api/endpoints/roles/rolesApi';
import { RoleModel } from '../../core/domainModels/roles/RoleModel';

export interface RolesState {
    roles: Array<RoleModel>;
    getRolesPending: boolean;
    getRolesError: string;
}

const initialState: RolesState = {
    roles: [],
    getRolesPending: false,
    getRolesError: '',
};

const name = 'roles';

const getRolesThunk = createAsyncThunk(`${name}/fetch`, async (params, thunkAPI) => {
    try {
        return await getRoles();
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

const rolesSlice = createSlice({
    name,
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getRolesThunk.pending, (state, action) => {
                state.getRolesPending = true;
                state.getRolesError = '';
            })
            .addCase(getRolesThunk.fulfilled, (state, action) => {
                state.getRolesError = '';
                state.roles = action.payload;
                state.getRolesPending = false;
            })
            .addCase(getRolesThunk.rejected, (state, action) => {
                state.getRolesPending = false;
                state.getRolesError = action.payload as string;
            });
    },
});

const { reducer } = rolesSlice;

export { reducer as rolesReducer };
export { getRolesThunk };
